<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div>
        BODOVI:
        <input type="number" v-model="achievementCode.pointsForCode" />
      </div>
      <div>
        OPIS:
        <input type="text" v-model="achievementCode.description" />
      </div>
      <div>
        AKTIVAN:
        <input type="checkbox" v-model="achievementCode.isActive" />
      </div>
      <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="saveDisabled" v-on:click="$emit('save', achievementCode)">SPREMI</button>
        <button type="button" v-on:click="$emit('cancel', achievementCode)">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', achievementCode)"></a>
  </div>
</template>

<script>
export default {
  name: 'AddEditAchievementCodeModal',
  props: {
    achievementCode: {},
  },
  computed: {
    saveDisabled: function() {
      return (
        !this.achievementCode.pointsForCode ||
        this.achievementCode.pointsForCode < 0 ||
        !this.achievementCode.description ||
        !this.achievementCode.description.length
      );
    },
  },
  created() {
    if (!this.achievementCode.hasOwnProperty('isActive')) this.achievementCode.isActive = false;
  },
};
</script>
